import React, { useEffect, useState } from 'react';
import Navbar from './Features/Navbar';
import { Box, CircularProgress } from '@mui/material';
import Footer from './Home/Footer';
import { Fade } from 'react-awesome-reveal';
import ExpertConnectionSections from './ExpertConnectionSections';
import { fetchExpertConnectionPage } from '../services/strapiExpertConnection';
import '../styles/expert-co.css';

/**
 * Page Expert Connection : Strapi (sections modulaires) + valeurs par défaut du site pour champs vides.
 */
export default function ExpertConnectionPageShell({ fadeTriggerOnce = true }) {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const data = await fetchExpertConnectionPage();
      if (!cancelled) {
        setPage(data);
        setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!page) return;
    document.title = `${page.pageTitle} | Tsahal Connection`;
  }, [page]);

  if (loading || !page) {
    return (
      <div className="expert-co">
        <Navbar />
        <Box sx={{ display: 'flex', justifyContent: 'center', minHeight: '40vh', alignItems: 'center' }}>
          <CircularProgress sx={{ color: '#2593C4' }} />
        </Box>
        <Footer />
      </div>
    );
  }

  const { pageTitle, pageSubtitle, ...sections } = page;

  return (
    <div className="expert-co">
      <Navbar />
      <Fade triggerOnce={fadeTriggerOnce}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginTop: '2rem',
          }}
        >
          <h1>{pageTitle}</h1>
          <h2>{pageSubtitle}</h2>
          <ExpertConnectionSections sections={sections} />
        </div>
        <Footer />
      </Fade>
    </div>
  );
}
